import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  useTheme,
} from '@mui/material';
import {ButtonVariants} from './enums';
import CircularButton from './circular';
import {FC, ReactNode} from 'react';

let ButtonShapetMap: {[key: string]: FC} = {};
ButtonShapetMap[ButtonVariants.CIRCULAR] = CircularButton;

type ButtonBaseProps = Pick<
  MuiButtonProps,
  | 'variant'
  | 'size'
  | 'color'
  | 'children'
  | 'sx'
  | 'onClick'
  | 'disableRipple'
  | 'onMouseEnter'
  | 'onMouseLeave'
  | 'startIcon'
  | 'href'
  | 'type'
  | 'disabled'
  | 'style'
  | 'component'
>;

export interface Props extends ButtonBaseProps {
  label?: string;
  icon?: ReactNode;
  shape?: 'rectangular' | 'circular';
  target?: string;
}

const Button = (props: Props) => {
  const {children, variant, shape, size, sx, ...prop} = props || {};

  const theme = useTheme();

  let styleObject: object = {
    fontSize: theme.typography.pxToRem(14),
  };
  const btnShape = shape || 'rectangular';
  const CustomComponent: any = ButtonShapetMap[btnShape];

  if (CustomComponent) return <CustomComponent {...props} />;

  if (variant == 'outlined' && size == 'large') {
    styleObject = {
      ...styleObject,
      border: 1,
      borderColor: 'primary.main',
      px: 2,
      fontWeight: theme.typography.fontWeightBold,
    };
  }

  styleObject = {...styleObject, ...sx};

  return (
    <MuiButton {...props} sx={styleObject}>
      {children}
    </MuiButton>
  );
};

export default Button;
